<div class="picture {{ imageSize }} {{ imageCenter }}" *ngIf="imageOptions">
    <img *ngIf="isSVG" role="img" [src]="imageUrl" [alt]="imageOptions.alt" />
    <img *ngIf="!isSVG" [src]="imageUrl" [attr.srcset]="imageUrl2x" [alt]="imageOptions.alt" />
</div>
